import styled from "styled-components";

const Styles = styled.div`
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 24px;

  @media all and (max-width: 767px) {
    font-size: 18px;
    margin-bottom: 15px;
  }
`;

export default Styles;
